var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row justify-content-center" }, [
    _c("div", { staticClass: "col-10" }, [
      _c("div", { staticClass: "row row align-items-center" }, [
        _c("div", { staticClass: "col-auto" }, [
          _c("img", {
            staticStyle: { height: "7rem" },
            attrs: {
              src: require("@Broker/@Assets/img/e-sign.png"),
              alt: _vm.$t("e-sign-package.eSign"),
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col text-center" }, [
          _c("p", { staticClass: "mb-0 text-gray" }, [
            _vm._v(
              "\n          " +
                _vm._s(
                  _vm.$t(
                    "e-sign-package.messages.yourClientCanNowSignDigitally"
                  )
                ) +
                "\n        "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "mb-0 text-gray" }, [
            _vm._v(
              "\n          " +
                _vm._s(_vm.$t("e-sign-package.messages.simplyCreateAPackage")) +
                "\n        "
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }